module.exports = __webpack_public_path__ + "static/media/5.7a71c05f.png";